<template>
  <div class="apply-form__section apply-form__privacy-policy">
    <h2>{{ $t('application.resumeLater') }}</h2>
    <p>{{ $t('application.resumeLaterInfo') }}</p>

    <div class="d-block d-md-flex align-center justify-end">
      <v-btn
        @click="$emit('save')"
        :block="blockButton"
        :loading="submitting"
        color="primary"
        class="ml-md-4 mt-4 mt-md-0 d-md-inline"
      >
        {{ $t('application.saveApplication') }}
        <v-icon class="ml-4">mdi-content-save</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    submitting: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  computed: {
    blockButton() {
      return (
        this.$vuetify.breakpoint.name === 'xs' ||
        this.$vuetify.breakpoint.name === 'sm'
      );
    }
  }
};
</script>
